import React from 'react';
import { CheckSquare, Leaf, Zap, Globe, Shield, Heart } from 'lucide-react';

const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-emerald-500" />
        Дополнительные критерии
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Экологически чистое производство */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="isEcoFriendly"
              checked={formData.isEcoFriendly}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Leaf className="w-4 h-4 mr-1 text-green-600" />
              Экологически чистое производство
            </span>
          </label>
          <p className="ml-6 text-xs text-gray-500 dark:text-gray-400 mt-1">
            Наличие соответствующих сертификатов и практик (+15% к субсидии)
          </p>
        </div>

        {/* Инновационные технологии */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="isInnovative"
              checked={formData.isInnovative}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Zap className="w-4 h-4 mr-1 text-amber-500" />
              Инновационные технологии
            </span>
          </label>
          <p className="ml-6 text-xs text-gray-500 dark:text-gray-400 mt-1">
            Использование передовых технологий и методов (+20% к субсидии)
          </p>
        </div>

        {/* Экспортная деятельность */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="isExporter"
              checked={formData.isExporter}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Globe className="w-4 h-4 mr-1 text-blue-500" />
              Экспортная деятельность
            </span>
          </label>
          <p className="ml-6 text-xs text-gray-500 dark:text-gray-400 mt-1">
            Осуществление экспорта сельхозпродукции (+10% к субсидии)
          </p>
        </div>

        {/* Наличие страхования */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="hasInsurance"
              checked={formData.hasInsurance}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Shield className="w-4 h-4 mr-1 text-purple-500" />
              Страхование рисков
            </span>
          </label>
          <p className="ml-6 text-xs text-gray-500 dark:text-gray-400 mt-1">
            Страхование урожая, скота и других активов (+5% к субсидии)
          </p>
        </div>

        {/* Социальные программы */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="hasSocialPrograms"
              checked={formData.hasSocialPrograms}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Heart className="w-4 h-4 mr-1 text-red-500" />
              Социальные программы
            </span>
          </label>
          <p className="ml-6 text-xs text-gray-500 dark:text-gray-400 mt-1">
            Участие в развитии сельских территорий, создание рабочих мест (+5% к субсидии)
          </p>
        </div>
      </div>

      {/* Программы субсидирования для расчета */}
      <h4 className="text-base font-medium text-gray-900 dark:text-white mt-6 mb-3">
        Программы субсидирования для расчета
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Капитальные гранты */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeCapitalGrants"
              checked={formData.includeCapitalGrants}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Гранты на капитальные затраты
            </span>
          </label>
        </div>

        {/* Операционные субсидии */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeOperationalSubsidies"
              checked={formData.includeOperationalSubsidies}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Субсидии на операционные расходы
            </span>
          </label>
        </div>

        {/* Кредитные субсидии */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeLoanSubsidies"
              checked={formData.includeLoanSubsidies}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Субсидирование процентной ставки
            </span>
          </label>
        </div>

        {/* Поддержка экспорта */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeExportSupport"
              checked={formData.includeExportSupport}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Поддержка экспорта
            </span>
          </label>
        </div>
      </div>
      
      <div className="bg-emerald-50 dark:bg-emerald-900/30 p-3 rounded-lg mt-4 text-xs text-emerald-800 dark:text-emerald-300">
        <p className="flex items-center">
          <CheckSquare className="w-4 h-4 mr-2 text-emerald-600 dark:text-emerald-400" />
          <span className="font-medium">Важно:</span> Наличие дополнительных критериев может значительно увеличить размер получаемых субсидий. Подробнее о требованиях и необходимых документах вы можете узнать в соответствующих разделах.
        </p>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;